import { render, staticRenderFns } from "./DynamicField.vue?vue&type=template&id=2f0495c6&scoped=true&"
import script from "./DynamicField.vue?vue&type=script&lang=js&"
export * from "./DynamicField.vue?vue&type=script&lang=js&"
import style0 from "./DynamicField.vue?vue&type=style&index=0&id=2f0495c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0495c6",
  null
  
)

export default component.exports